











import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import { IItemsStyle, ItemSeparatorKinds } from "../../../../domain/format/objects";

@Component({
  components: {
    OptionDropDownSelector,
  }
})

export default class ItemsStyleEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: IItemsStyle) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IItemsStyle) => T, defaultValue: T) => T;
  
  get kind(): ItemSeparatorKinds {
    return this.readPropertyOrDefault(s => s.separator, undefined);
  }

  set kind(value: ItemSeparatorKinds) {
    this.writePropertyWhenValid(s => s.separator = value);
  }

  kindOptions: StandardOption<number>[] = [
    new StandardOption<number>("・", ItemSeparatorKinds.FullWidthPoint),
    new StandardOption<number>("改行", ItemSeparatorKinds.NewLine),
    new StandardOption<number>("読点", ItemSeparatorKinds.FullWidthToten),
    new StandardOption<number>("全角カンマ", ItemSeparatorKinds.FullWidthComma),
    new StandardOption<number>("全角スペース", ItemSeparatorKinds.FullWidthSpace),
  ];
}
